<template>
  <ion-header>
    <ion-toolbar>
      <ion-item lines="none">
        <ion-title>{{ $t('datalegal') }}</ion-title>
        <ion-icon slot="end" style="font-size: 30px;" @click="closeDialog()" :ios="closeOutline" :md="closeOutline" name="closeOutline"></ion-icon>
      </ion-item>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-card><ion-card-content style="white-space: pre-wrap;">{{ datalegal }}  </ion-card-content>
    </ion-card>
  </ion-content>
</template>

<script>
import { IonButton, IonContent, IonHeader, IonTitle, toastController, IonCardContent, 
IonToolbar, IonLabel, IonInput, IonItem, IonList, IonIcon, IonItemDivider,
IonGrid, IonCol, IonRow, modalController, IonCheckbox, IonCard, IonCardHeader, IonCardTitle, isPlatform,
IonAvatar } from '@ionic/vue';
import { defineComponent, computed } from 'vue';
import { closeOutline } from 'ionicons/icons';
import getDatalegalQueryFile from '../../graphql/getDatalegal.query.gql'
import { useQuery, } from '@vue/apollo-composable'

export default defineComponent({
  name: 'DataLegalDialog',
  components: { IonButton, IonContent, IonHeader, IonTitle, IonToolbar,IonLabel, IonInput, IonItem, 
                IonList, IonIcon, IonGrid, IonCol, IonRow, IonItemDivider, IonCheckbox, IonCard, IonCardHeader,
                IonCardTitle, IonAvatar,IonCardContent
              },
  setup() {
    const { result: getDatalegal } = useQuery(getDatalegalQueryFile, null, { fetchPolicy: 'no-cache' })
    
    // TODO: delete – useResult deprecated
    // const datalegal = useResult(getDatalegal, null, data => data.getDatalegal.datalegal)
    const datalegal = computed(() => getDatalegal.value?.getDatalegal?.datalegal ?? null)


    return { 
      closeOutline, datalegal
    }
  },
  methods: {
    closeDialog() {
      return modalController.dismiss()
    },
  }
});
</script>